import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalConfig, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss'],
  providers: [NgbModalConfig, NgbModal]

})
export class AccueilComponent implements OnInit {
  constructor(private utilitiesServices:UtilitiesService) {}  

  ngOnInit(): void {
    this.utilitiesServices.sendInformationQrCode(true);
    sessionStorage.setItem('pageHome', "valHome")  ;
  }


  goPlay(){
    sessionStorage.removeItem('pageHome')    
    window.open("https://play.google.com/store/apps/details?id=com.orange.ci.mybox", "_blank");
  }

  goApple(){
    sessionStorage.removeItem('pageHome')    
    window.open("https://apps.apple.com/ci/app/ma-box-orange-c%C3%B4te-divoire/id6544801435", "_blank");
  }

  goAppGallery(){
    sessionStorage.removeItem('pageHome')    
    window.open("https://appgallery.cloud.huawei.com/ag/n/app/C104755769?locale=en_US&source=appshare&subsource=C104755769&shareTo=org.telegram.messenger&shareFrom=appmarket&shareIds=07d0d06748f244a1bbdf1a0359d7e9ce_org.telegram.messenger&callType=SHARE", "_blank");
  }
 
  fermerHamburgerMenu(){
        this.utilitiesServices.sendInformationDataFermerHamburger(false)
      }


}
